/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Failed_Unsupported_ScopeInputs */

const en_mcp_connect_failed_unsupported_scope = /** @type {(inputs: Mcp_Connect_Failed_Unsupported_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This app asked for access that Listening doesn’t support.`)
};

const es_mcp_connect_failed_unsupported_scope = /** @type {(inputs: Mcp_Connect_Failed_Unsupported_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta app pidió un acceso que Listening no admite.`)
};

/**
* | output |
* | --- |
* | "This app asked for access that Listening doesn’t support." |
*
* @param {Mcp_Connect_Failed_Unsupported_ScopeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_failed_unsupported_scope = /** @type {((inputs?: Mcp_Connect_Failed_Unsupported_ScopeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Failed_Unsupported_ScopeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_failed_unsupported_scope(inputs)
	return en_mcp_connect_failed_unsupported_scope(inputs)
});